export const SET_PHARMACY_DATA = 'SET_PHARMACY_DATA'
export const SET_PHARMACY_ADDRESS_DATA = 'SET_PHARMACY_ADDRESS_DATA'